export default __webpack_public_path__ + "static/media/gas_phase_image.ffb04eac.png";